<style src="./Properties.scss" lang="scss" scoped></style>

<template src="./Properties.html" />

<script>
import Card from '../Card/Card.vue';

export default {
  name: 'Properties',
  components: {
    Card,
  },
  props: ['properties'],
};
</script>
